import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// Import des traductions
import translationFR from './locales/fr/index.js';
import translationEN from './locales/en/index.js';
import playbooksFR from './locales/fr/playbooks.json';
import playbooksEN from './locales/en/playbooks.json';
import componentsFR from './locales/fr/modules/components.json';
import componentsEN from './locales/en/modules/components.json';

// Configuration des langues disponibles
export const SUPPORTED_LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' }
];

// Ressources de traduction
const resources = {
  fr: {
    translation: translationFR,
    playbooks: playbooksFR,
    components: componentsFR
  },
  en: {
    translation: translationEN,
    playbooks: playbooksEN,
    components: componentsEN
  }
};

i18n
  // Configuration React i18next (retiré LanguageDetector pour éviter les conflits)
  .use(initReactI18next)
  // Initialisation
  .init({
    // Ressources de traduction
    resources,
    
    // Langue par défaut
    fallbackLng: 'fr',
    
    // Langue définie explicitement (pas de détection automatique)
    lng: localStorage.getItem('nodemented-language') || 'fr',
    
    // Pas de détection automatique pour éviter les conflits
    // detection: {
    //   order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    //   lookupLocalStorage: 'nodemented-language',
    //   caches: ['localStorage'],
    // },
    
    // Configuration de l'interpolation
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
    
    // Configuration du debug (uniquement en développement)
    debug: process.env.NODE_ENV === 'development',
    
    // Configuration des namespaces
  ns: ['translation', 'playbooks', 'components'],
  defaultNS: 'translation',
    
    // Comportement en cas de clé manquante
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lng, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`🌍 Clé de traduction manquante: [${lng}] ${key}`);
      }
    },
    
    // Options de formatage
    returnEmptyString: false,
    returnNull: false,
  });

// Fonction utilitaire pour changer de langue
export const changeLanguage = (langCode) => {
  i18n.changeLanguage(langCode);
  localStorage.setItem('nodemented-language', langCode);
  
  // Log pour debug
  console.log(`🌍 Langue changée vers: ${langCode}`);
};

// Fonction utilitaire pour obtenir la langue actuelle
export const getCurrentLanguage = () => {
  return i18n.language || 'fr';
};

// Fonction utilitaire pour obtenir les informations de la langue actuelle
export const getCurrentLanguageInfo = () => {
  const currentLang = getCurrentLanguage();
  return SUPPORTED_LANGUAGES.find(lang => lang.code === currentLang) || SUPPORTED_LANGUAGES[0];
};

export default i18n;
